import React from 'react';

import { Typography } from '@mui/material';
import { getIsReportGridRow, OCRRunningCell, useCellStyles } from 'src/components';
import type { ReportRow } from 'src/components';
import { PulseIcon, PulseIconVariant } from 'src/components/icons/Pulse';
import { RepositoryPartiesList } from 'src/components/repository/RepositoryPartiesList';
import {
  getOCRStatusFromFileVersion,
  OCRStatus,
} from 'src/editor/toolbars/right-panel/ai/shared/OCRStatusOrChildren';

export function RepositoryPartiesCell({ row }: { row: ReportRow }): JSX.Element {
  const classes = useCellStyles();

  if (!getIsReportGridRow(row)) return <div className={classes.cell} />;

  const ocrStatus = getOCRStatusFromFileVersion(row.latestVersion);
  const isAiSettingParties = Boolean(
    row.coreAiPropertiesExtractionStartedAt &&
    !row.coreAiPropertiesExtractionFinishedAt &&
    !row.coreAiPropertiesExtractionFailedAt
  );

  if (ocrStatus === OCRStatus.Running) return <OCRRunningCell pulsePosition="left" />;
  if (isAiSettingParties) {
    return (
      <div className={classes.cell}>
        <PulseIcon variant={PulseIconVariant.LoadingPrimary} />
        <Typography noWrap variant="body1">
          Ai setting parties...
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.cell}>
      <RepositoryPartiesList document={row} position="bottom" />
    </div>
  );
}
